import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://f13dpf-q0.myshopify.com/cart/47706120126618:1?channel=buy_button';
const resultImages = ['https://cdn.magicpatterns.com/uploads/eA7mtCbRQrGw8Qn2PutU2F/WhatsApp_Image_2026-05-03_at_07.20.44.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/wL6aGDqFb48777ZA8eDtJx/WhatsApp_Image_2026-05-03_at_06.59.12.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const beforeImages = ['https://cdn.magicpatterns.com/uploads/befWjZNtk1Kzw6ruZphVyD/WhatsApp_Image_2026-05-02_at_22.08.03_(2).jpg', 'https://cdn.magicpatterns.com/uploads/g1egev8N4akbkZNtXocYzF/WhatsApp_Image_2026-05-02_at_22.08.03.jpg', 'https://cdn.magicpatterns.com/uploads/2K1CzXbcjYAezJTLa9sUSn/WhatsApp_Image_2026-05-02_at_22.15.42_(1).jpg'];
const lifeImages = ['https://cdn.magicpatterns.com/uploads/fQpJkUjt1R3RWzkwYt6DaD/WhatsApp_Image_2026-05-02_at_22.20.20.jpg', 'https://cdn.magicpatterns.com/uploads/nTYCMskRwtN3osvAAzwFK9/WhatsApp_Image_2026-05-02_at_22.58.39.jpg', 'https://cdn.magicpatterns.com/uploads/83qTWzNa1nqYosmjdMaVi9/WhatsApp_Image_2026-05-02_at_23.53.22_(1).jpg', 'https://cdn.magicpatterns.com/uploads/iKzX9YnRdfca4AtUQnuC7g/IMG_7620.jpg', 'https://cdn.magicpatterns.com/uploads/7pByoThoZobCp5UhEwvcCv/WhatsApp_Image_2026-05-02_at_22.17.47.jpg', 'https://cdn.magicpatterns.com/uploads/asz4YqNpKLw8V6zPXc73Lu/WhatsApp_Image_2026-05-03_at_00.02.17.jpg', 'https://cdn.magicpatterns.com/uploads/g7jZp64b5GLUsbZUNNBYAU/IMG_7698.jpg', 'https://cdn.magicpatterns.com/uploads/6CHYXvBen1tpaSGGrt4EXT/WhatsApp_Image_2026-05-02_at_22.08.03_(3).jpg', 'https://cdn.magicpatterns.com/uploads/gQPiCcLr1e4JCbD6QFhttA/WhatsApp_Image_2026-05-03_at_00.00.02.jpg', 'https://cdn.magicpatterns.com/uploads/wjdE8UQBY1NPoYxHp531V2/WhatsApp_Image_2026-05-03_at_00.05.58.jpg'];
export function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [beforeSlide, setBeforeSlide] = useState(0);
  const [lifeSlide, setLifeSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % resultImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setBeforeSlide(prev => (prev + 1) % beforeImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setLifeSlide(prev => (prev + 1) % lifeImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const goTo = (index: number) => setCurrentSlide(index);
  const goPrev = () => setCurrentSlide(prev => (prev - 1 + resultImages.length) % resultImages.length);
  const goNext = () => setCurrentSlide(prev => (prev + 1) % resultImages.length);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const painPoints = [{
    emoji: '❌',
    before: 'Ves cómo todos venden por internet pero ',
    bold: 'no sabés cómo empezar',
    after: ''
  }, {
    emoji: '❌',
    before: '¿Ganas menos de $3.000 usd y ',
    bold: 'no te alcanza?',
    after: ''
  }, {
    emoji: '❌',
    before: '¿Estas atrapado en una rutina que no te llena y ',
    bold: 'no sabes como salir de ahi...',
    after: ''
  }, {
    emoji: '❌',
    before: '¿Compraste MIL cursos/mentorías y seguís ',
    bold: 'FRUSTRADO/A sin lograr vivir de internet?',
    after: '💰💻'
  }, {
    emoji: '❌',
    before: '¿Te cuesta avanzar SOLO/A y necesitas ',
    bold: 'acompañamiento REAL en VIVO?',
    after: ''
  }];
  return <section className="py-6 md:py-10 px-4 pt-[0px] pb-[0px] bg-[#2F0240]" data-id="element-104">
      <div className="max-w-6xl mx-auto" data-id="element-105">
        <div className="text-center mb-8" data-id="element-106">
          <div className="inline-flex items-center gap-2 text-white px-6 py-2.5 rounded-full font-bold text-sm uppercase tracking-wider shadow-[0_0_15px_rgba(34,197,94,0.5)] animate-glow-badge pt-[6px] pb-[6px] mt-[10px] mb-[10px] bg-[#9C16A3]" data-id="element-107">
            <span data-id="element-108"></span>
            <span data-id="element-109">💰DOMINANDO SHOPIFY💰</span>
          </div>

          <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight max-w-5xl mx-auto uppercase text-[#FFFFFF]" data-id="element-110">
            CREÁ Y VENDÉ TU PRIMER{' '}
            <span className="text-[#FC9DFF] bg-[2F0240]" data-id="element-111">EBOOK</span> EN{' '}
            <span className="text-[#FC9DFF]" data-id="element-112">72 HS</span> Y GENERÁ{' '}
            <span className="underline decoration-4 decoration-yellow-400 text-[#FC9DFF]" data-id="element-113">
              $100 A $300 USD DIARIOS
            </span>{' '}
            EN <span className="text-[#FC9DFF]" data-id="element-114">AUTOMÁTICO</span>
          </h2>

          <div className="flex justify-center mb-8" data-id="element-115">
            <img src="https://cdn.magicpatterns.com/uploads/xntdg5Nr6p8J4aPupFKMFj/Diseno_sin_titulo_(1).png" alt="Dominando Shopify - Método Probado" loading="lazy" className="w-full max-w-lg rounded-lg shadow-2xl aspect-square object-cover mt-[-20px] mb-[-20px]" data-id="element-116" />
          </div>

          <p className="md:text-2xl max-w-4xl mx-auto text-[#FACC15] text-[14px] pt-[0px] pb-[0px] mt-[30px] mb-[30px]" data-id="element-117">
            ⭐+500 Alumnos ⚡Acceso inmediato 🛡️ Garantía 7 días 🔒 Pago seguro
            💳 Mercado Pago
          </p>

          <div className="rounded-xl p-6 mb-8 max-w-3xl mx-auto bg-[#9C16A3] animate-neon-violet" data-id="element-118">
            <p className="md:text-xl font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[16.5px]" data-id="element-119">
              Generamos💰+$70 Millones en los últimos 6 meses → y te enseñamos
              el PASO a PASO ✅ Desde CERO ✅ Sin Experiencia ✅
            </p>
          </div>

          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-120"></p>
        </div>

        <div className="text-center mt-[-10px] mb-[-10px]" data-id="element-121">
          <CTAButton text="QUIERO ACCEDER AHORA👉🏻" onClick={scrollToCompra} size="large" className="w-full md:w-auto text-2xl animate-pulse-green" data-id="element-122" />
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-123">
          <h3 className="text-2xl md:text-3xl font-black text-center uppercase text-[#FFFFFF] mt-[20px] mb-[20px]" data-id="element-124">
            Nuestros Resultados👇
          </h3>
          <div className="relative" data-id="element-125">
            <div className="overflow-hidden rounded-2xl border-2 border-[#FC9DFF] shadow-xl" data-id="element-126">
              <div className="flex transition-transform duration-500 ease-in-out" style={{
              transform: `translateX(-${currentSlide * 100}%)`
            }} data-id="element-127">
                {resultImages.map((img, index) => <img key={index} src={img} alt={`Resultado ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-[9/16]" data-id="element-128" />)}
              </div>
            </div>

            <button onClick={goPrev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" data-id="element-129">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-130" />
            </button>
            <button onClick={goNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" data-id="element-131">
              <ChevronRightIcon className="w-5 h-5" data-id="element-132" />
            </button>

            <div className="flex justify-center gap-2 mt-4" data-id="element-133">
              {resultImages.map((_, index) => <button key={index} onClick={() => goTo(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-134" />)}
            </div>
          </div>
        </div>

        <div className="rounded-2xl p-8 md:p-10 mb-10 max-w-3xl mx-auto bg-[#3E0400]" data-id="element-135">
          <h3 className="text-3xl md:text-4xl font-black text-white mb-8 text-center" data-id="element-136">
            ¿TE IDENTIFICAS?
          </h3>
          <div className="space-y-4" data-id="element-137">
            {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 border border-amber-600/40 rounded-xl px-5 py-4 bg-gray-900/60" data-id="element-138">
                <span className="text-2xl flex-shrink-0 bg-gray-800 rounded-lg w-10 h-10 flex items-center justify-center" data-id="element-139">
                  {point.emoji}
                </span>
                <p className="text-base md:text-lg font-medium text-[#FFFFFF]" data-id="element-140">
                  {point.before}
                  <span className="font-bold text-[#FC9DFF]" data-id="element-141">{point.bold}</span>
                  {point.after}
                </p>
              </div>)}
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center" data-id="element-142">
          <p className="md:text-xl mb-3 font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[20px]" data-id="element-143">
            Te entendemos... Nosotros también estuvimos ahí...💔
          </p>
        </div>

        <div className="max-w-md mx-auto mb-4" data-id="element-144">
          <div className="relative" data-id="element-145">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-146">
              <div className="flex transition-transform duration-700 ease-in-out" style={{
              transform: `translateX(-${beforeSlide * 100}%)`
            }} data-id="element-147">
                {beforeImages.map((img, index) => <img key={index} src={img} alt={`Nuestra vida antes ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-square" data-id="element-148" />)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-3" data-id="element-149">
              {beforeImages.map((_, index) => <button key={index} onClick={() => setBeforeSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${beforeSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-150" />)}
            </div>
          </div>
          <p className="text-center md:text-lg text-gray-200 mt-4 px-2 text-[17px] font-[Montserrat,_sans-serif] font-[500]" data-id="element-151">
            Esta era nuestra vida antes: de casa al trabajo, del trabajo a casa.
            Sin tiempo... Sin dinero...estresados, endeudados y frustrados.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-10" data-id="element-152">
          <h3 className="text-2xl md:text-4xl font-black text-[#FACC15] leading-tight" data-id="element-153">
            Y gracias a vender productos digitales...
          </h3>
        </div>

        <div className="max-w-md mx-auto mb-4" data-id="element-154">
          <div className="relative" data-id="element-155">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-156">
              <div className="flex transition-transform duration-700 ease-in-out" style={{
              transform: `translateX(-${lifeSlide * 100}%)`
            }} data-id="element-157">
                {lifeImages.map((img, index) => <img key={index} src={img} alt={`Nuestra vida ahora ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-[9/16]" data-id="element-158" />)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-3" data-id="element-159">
              {lifeImages.map((_, index) => <button key={index} onClick={() => setLifeSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${lifeSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-160" />)}
            </div>
          </div>
          <p className="text-center md:text-lg text-gray-200 mt-4 font-medium px-2 text-[17px] font-[Montserrat,_sans-serif]" data-id="element-161">
            ❤️Nuestras vidas cambiaron❤️Hoy tenemos paz mental, libertad,
            tiempo, dinero y muchos viajes.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-12" data-id="element-162">
          <h3 className="md:text-4xl mb-4 text-[20px] font-[700] font-[Montserrat,_sans-serif] text-[#FC9DFF]" data-id="element-163">
            Y vos también podes mejorar tu estilo de vida...
          </h3>
          <p className="text-xl md:text-2xl font-semibold text-white font-[Montserrat,_sans-serif]" data-id="element-164">
            Es por eso que creamos el Programa{' '}
            <span className="text-[#FC9DFF] font-black" data-id="element-165">DOMINANDO SHOPIFY</span>
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-166">
          <img src="https://cdn.magicpatterns.com/uploads/fcRwvhZ941oy9wboiX5iMk/mockup_dominando_shopify.png" alt="Programa Dominando Shopify - Mockup" loading="lazy" className="w-full rounded-2xl shadow-2xl" data-id="element-167" />
          <p className="text-center md:text-lg text-gray-200 mt-6 font-medium px-2 text-[17px] font-[Montserrat,_sans-serif]" data-id="element-168">
            📚 Donde te enseñamos paso a paso a crear, lanzar y escalar tu
            tienda online con Shopify + Meta Ads desde cero.
          </p>
        </div>
      </div>
    </section>;
}